import {useEffect, useMemo} from "react";

// indexPosition - ile kolumn najwyższego poziomu stoi przed indeksem (w trybie grupowania kolumny poziomów)
export default function AsyncTableColGroups({
    headers,
    shouldIndex,
    table,
    indexPosition = 0,
}) {
    const colSpans = useMemo(() => {
        let tmp = [];
        const countColumns = (item) => {
            if (item.children) {
                return item.children.reduce(
                    (sum, child) => sum + countColumns(child),
                    0
                );
            }
            return 1;
        };

        tmp.push(...headers.map((header) => countColumns(header)));
        if (shouldIndex) tmp.splice(indexPosition, 0, 1);
        return tmp;
    }, [headers, shouldIndex, indexPosition]);

    useEffect(() => {
        const headers = Array.from(
            table.current.querySelectorAll("th[data-children='false']")
        );
        const widths = headers.map((th) => th.getBoundingClientRect().width);

        const cols = table.current.querySelectorAll("colgroup col");
        widths.forEach((w, i) => {
            cols[i].style.width = `${w}px`;
        });

        table.current.style.width = widths.reduce((a, b) => a + b, 0) + "px";
        table.current.style.tableLayout = "fixed";
    }, [table]);

    return colSpans.map((item, index) => (
        <colgroup key={index}>
            {new Array(item).fill(0).map((_, index) => (
                <col key={index} />
            ))}
        </colgroup>
    ));
}
